<!-- 视频模块 - 默认方式 -->
<template>
  <div
    ref="defaultVideo"
    class="default-video"
    :class="{
      'default-video--playing': playing,
    }"
  >
    <!-- ifram 视频 -->
    <youtube
      v-if="videoId"
      class="default-video__video"
      :video-id="videoId"
      ref="youtube"
      :player-vars="playerVars"
      @ready="ready"
      @error="error"
    />

    <template v-if="image.url || bgImg">
      <!-- 封面 -->
      <div v-if="!playing" class="default-video__poster">
        <v-lazy-img class="default-video__poster-img" :data-url="image.url || bgImg"/>
        <!-- 文本内容 -->
        <div class="default-video__content" :class="`default-video__content--${layoutClass[config['layout']]}`">
          <div class="video-content">
            <p class="default-video__title" v-if="config['title']">{{ config['title'] }}</p>
            <p class="default-video__desc" v-if="config['description']">{{ config['description'] }}</p>
          </div>
        </div>
        <!-- 播放按钮 -->
        <i v-if="isReady" @click="play" class="default-video__button iconfont icon-bofang1" />
      </div>
    </template>
  </div>
</template>

<script>
//import LazyImg from '@/js/components/LazyImg.vue'
import VueYoutube from 'vue-youtube'
import defaultBgImg from '@/images/defaultBanner.jpg'
import { urlToQueryData } from '@/js/lib/util'

Vue.use(VueYoutube)

export default {
  // components: { LazyImg },
  name: 'defaultVideo',
  props: {
    config: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      image: this.config?.image || {},
      videoSrc: null,
      playing: false,
      isReady: false,
      videoId: null,
      bgImg: null,
      playerVars: {
        autoplay: 0,
        loop: 1,
        rel: 0,
        hd: 1,
        showinfo: 0,
        color: 'white',
        controls: 1,
        mute: 1,
        modestbranding: 1,
        vq: 720,
      },
      layoutClass: {
        left: 'middle-left',
        center: 'middle-center',
        right: 'middle-right',
        bottom_left: 'bottom-left',
        bottom_right: 'bottom-right',
        bottom_center: 'bottom-center',
      },
    }
  },
  mounted() {
    const { video_url, image } = this.config

    this.getYoutubeId(video_url)

    if (!this.videoId && !image?.url) {
      this.bgImg = defaultBgImg
    }

    // 自动播放的话，需要滚动到指定位置才开始播放
    if (this.config.autoplay) {
      // 添加滚动监听事件
      window.addEventListener('scroll', this.windowScroll)
    }
  },
  methods: {
    // get youtubeid
    // 获取youtube的id
    // url的最后一段数据就是
    getYoutubeId(url) {
      if (!url) {
        this.videoId = null
        return
      }

      const urlData = urlToQueryData(url)

      this.videoId = urlData?.query?.v || urlData.pathName || null;
      this.playerVars.playlist = this.videoId
    },
    windowScroll() {
      const top = this.$refs.defaultVideo.offsetTop
      const height = document.documentElement.clientHeight
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop

      // 滚动到指定位置，开始播放视频
      if (scrollTop + height - 100 > top && this.ready) {
        this.play()
        // 成功播放后，移除监听
        window.removeEventListener('scroll', this.windowScroll)
      }
    },
    play() {
      if (this.isReady) {
        this.playing = true
        this.player.playVideo()
      }
    },
    // 视屏加载结束
    ready() {
      this.isReady = true

      if (this.config.autoplay) {
        // 滚动监听
        this.windowScroll()
      }
    },
    // 加载失败
    error(event) {
      this.playing = false
      this.isReady = false
    },
  },
  computed: {
    player() {
      return this.$refs.youtube.player
    },
  },
  destroyed() {
    window.removeEventListener('scroll', this.windowScroll)
  },
}
</script>

<style lang="scss" scoped>
.default-video {
  position: relative;
  padding-bottom: 56.25%;
  ::v-deep {
    .default-video {
      &__video {
        height: 100%;
        width: 100%;
        position: absolute;
        z-index: 1;
        transition: all 0.2s;
      }
    }
  }
  &__poster {
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 3;
    transition: all 0.3s;
    opacity: 1;
  }
  &__poster-img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
  &__content {
    display: flex;
    width: 100%;
    position: absolute;
    z-index: 2;
    color: #fff;
    line-height: 1.4;
    padding-left: 40px;
    padding-right: 40px;
    left: 0;
    text-align: left;
    top: 50%;
    padding-top: 90px;
    .video-content {
      width: 500px;
      max-width: 100%;
    }
    &--middle-center {
      text-align: center;
      top: 50%;
      padding-top: 90px;
      justify-content: center;
    }
    &--middle-left {
      text-align: left;
      top: 50%;
      padding-top: 90px;
    }
    &--middle-right {
      text-align: left;
      top: 50%;
      padding-top: 90px;
      justify-content: end;
    }
    &--bottom-left,
    &--bottom-center,
    &--bottom-right {
      top: unset;
      bottom: 100px;
    }
    &--middle-left,
    &--bottom-left {
      .video-content {
        text-align: left;
      }
    }
    &--middle-right,
    &--bottom-right {
      justify-content: flex-end;
      .video-content {
        text-align: right;
      }
    }
    &--middle-center,
    &--bottom-center {
      justify-content: center;
      .video-content {
        text-align: center;
      }
    }
  }
  &__title {
    font-size: 70px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    font-family: var(--title-font-family);
  }
  &__desc {
    margin-top: 16px;
    font-size: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    font-family: var(--text-font-family);
  }
  &__button {
    cursor: pointer;
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 60px;
    color: #ccc;
    transition: color 0.2s;
    z-index: 3;
  }
  &:hover {
    .default-video {
      &__button {
        color: #fff;
      }
    }
  }
  &--playing {
    .default-video {
      &__poster {
        opacity: 0;
        z-index: -2;
      }
    }
  }
  @media screen and (max-width: 1200px) {
    height: 640px;
    padding-bottom: 0;
  }
  @media screen and (max-width: 767px) {
    height: 560px;
    &__content {
      padding-left: 20px;
      padding-right: 20px;
    }
    &__title {
      font-size: 35px;
    }
    &__desc {
      font-size: 12px;
      margin-top: 8px;
    }
    &__button {
      font-size: 80px;
    }
  }
}
</style>
